/**
 * Schritttext mit eingesetzten Mengen: Platzhalter wie {mehl} werden durch
 * die umgerechnete Menge ersetzt und hervorgehoben.
 */
import { renderStepText } from '@cookbook/domain';
import type { UnitMode } from '@cookbook/domain';
import type { Ingredient } from '../api/types.ts';
import { texts } from '../texts/de.ts';

/** Eigenschaften des Schritttexts. */
export interface StepTextProps {
  readonly text: string;
  readonly ingredients: readonly Ingredient[];
  readonly factor: number;
  readonly unitMode: UnitMode;
  readonly className?: string;
}

/** Schritttext mit Mengen. */
export function StepText({ text, ingredients, factor, unitMode, className = '' }: StepTextProps) {
  const parts = renderStepText(text, ingredients, factor, unitMode);
  return (
    <p className={`whitespace-pre-line ${className}`}>
      {parts.map((part, index) =>
        part.kind === 'amount' ? (
          <strong key={index} className="font-semibold text-accent-strong">
            {part.text}
          </strong>
        ) : part.kind === 'unknown' ? (
          <span key={index} title={texts.scale.unknownPlaceholder} className="text-content-muted">
            {part.text}
          </span>
        ) : (
          <span key={index}>{part.text}</span>
        ),
      )}
    </p>
  );
}
